import { useContext } from "react";
import { useSelector } from "react-redux";
import { node } from "prop-types";
import { navigationPropType } from "@template/state/modules/navigation";
import {
  trackPageInteraction,
  getGender,
  ANALYTICS_INTERACTION_CLICK,
  ANALYTICS_POSITION_HEADER,
  ANALYTICS_CONTEXT
} from "@src/helpers/eventing/events";
import { addAnalyticsDataToLink } from "@template/helpers/addAnalyticsDataToLink";
import {
  addCtaRefToUrl,
  generateNavigationCtaRef
} from "@template/helpers/addCtaRefToUrl";
import { getLoyaltyStatus } from "@template/state/modules/loyalty";
import { NavigationContext } from "../NavigationContext";
import { fullPageNavigationDecider } from "@src/client/navigationBroker";

const NavAnchor = ({ item, children, ...restOfProps }) => {
  const closeNavigationMenu = useContext(NavigationContext);
  const loyaltyStatus = useSelector(getLoyaltyStatus);
  const {
    optedIn: isOptedInToLoyalty = false,
    isAvailable: isLoyaltyAvailable = false
  } = loyaltyStatus || {};

  const target = item.linkType === "external" ? "_blank" : null;
  let href = addAnalyticsDataToLink(item);

  const isNewInTodayLink = item.loyaltyBenefitType === "EarlyAccessToNewIn";

  const shouldAddCtaRef =
    isLoyaltyAvailable && isNewInTodayLink && !isOptedInToLoyalty;

  if (shouldAddCtaRef && item.gender) {
    const ctaRef = generateNavigationCtaRef(item);
    href = addCtaRefToUrl(href, ctaRef);
  }

  const handleClick = event => {
    const { gender, label } = item;

    trackPageInteraction({
      context: ANALYTICS_CONTEXT.openNav,
      interaction: ANALYTICS_INTERACTION_CLICK,
      elementText: label,
      properties: {
        positionOnPage: ANALYTICS_POSITION_HEADER,
        gender: getGender(gender)
      }
    });

    fullPageNavigationDecider(href, event);

    closeNavigationMenu();
  };

  return (
    <a {...restOfProps} onClick={handleClick} href={href} target={target}>
      {children}
    </a>
  );
};

NavAnchor.propTypes = {
  item: navigationPropType.isRequired,
  children: node.isRequired
};

export default NavAnchor;
